export default __webpack_public_path__ + "static/aneta-9db2bdda113ce0a73a8ad92b3c792205.jpg";